import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { Stakeable } from "@modules/staking/domain/entities/stakeable.model";
import { StakeableAvailability } from "@modules/staking/domain/entities/stakable-availability.model";
import { StakingModalFlowModel } from "@modules/staking/domain/entities/staking-modal-flow.model";
import { Feature } from "@models/feature-list";

@Component({
	selector: "staking-reward-actions",
	templateUrl: "staking-reward-actions.component.html",
	styleUrls: ["staking-reward-actions.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class StakingRewardActionsComponent {
	public availabilityStates = StakeableAvailability;
	public featureList = Feature;

	@Input() stakedAsset: Stakeable = null;
	@Output() flowClick: EventEmitter<StakingModalFlowModel> = new EventEmitter<StakingModalFlowModel>();

	public clickFlow(modalType: string, stakeable: Stakeable | null = null): void {
		this.flowClick.emit({ modalType, stakeable });
	}
}
